import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'rc-slider';
import { Box } from 'roo-ui/components';
import 'rc-slider/assets/index.css';
import theme from 'lib/theme';

const PointsPaySlider = ({ minCashAmount, maxCashAmount, initialCashAmount, onChange }) => (
  <Box>
    <Slider
      min={minCashAmount}
      max={maxCashAmount}
      defaultValue={initialCashAmount}
      onChange={onChange}
      step={0.01}
      railStyle={theme.slider.rail}
      trackStyle={{ ...theme.slider.track, background: theme.colors.greys.alto }}
      handleStyle={theme.slider.handle}
      ariaLabelForHandle="Use Qantas Points and cash"
    />
  </Box>
);

PointsPaySlider.propTypes = {
  minCashAmount: PropTypes.number.isRequired,
  maxCashAmount: PropTypes.number.isRequired,
  initialCashAmount: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default PointsPaySlider;
